// extracted by mini-css-extract-plugin
module.exports = {"unlikebtn":"likebtnstyle_unlikebtn__ZDykK"};